/**
 * Sort announcements: weighted items first (weight desc), then unweighted (updatedAt desc).
 */

export type AnnouncementSortable = {
  weight?: number | null;
  updatedAt: number;
};

function hasWeight(item: AnnouncementSortable): boolean {
  return item.weight != null && Number.isFinite(item.weight);
}

export function compareAnnouncements(
  a: AnnouncementSortable,
  b: AnnouncementSortable
): number {
  const aWeighted = hasWeight(a);
  const bWeighted = hasWeight(b);

  if (aWeighted && bWeighted) {
    const weightDiff = (b.weight as number) - (a.weight as number);
    if (weightDiff !== 0) return weightDiff;
    return b.updatedAt - a.updatedAt;
  }

  if (aWeighted && !bWeighted) return -1;
  if (!aWeighted && bWeighted) return 1;

  return b.updatedAt - a.updatedAt;
}

export function sortAnnouncements<T extends AnnouncementSortable>(items: T[]): T[] {
  return [...items].sort(compareAnnouncements);
}
